import type { ReactNode } from 'react';

/**
 * A friendly "nothing here yet" placeholder — an icon, a title, and a short hint —
 * so empty lists guide the user instead of showing bare text.
 */
export function EmptyState({
  icon,
  title,
  hint,
  className = '',
}: {
  icon?: ReactNode;
  title: string;
  hint?: string;
  className?: string;
}) {
  return (
    <div className={`text-center py-10 px-4 bg-white rounded-2xl border border-slate-100 shadow-sm shadow-slate-200/50 ${className}`}>
      <div className="text-gray-400 flex justify-center mb-2">
        {icon ?? (
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        )}
      </div>
      <p className="text-sm font-medium text-gray-600">{title}</p>
      {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
    </div>
  );
}
